import CompanyLogo from '@/components/company/CompanyLogo';
import CompanyLink from '@/components/navigation/CompanyLink';
import { useTranslation } from 'next-i18next';

export default function RelatedCompanies({ companies }) {
	const { t } = useTranslation('companies');
	return (
		<div className="bg-white py-8">
			<div className="mx-auto max-w-2xl lg:max-w-none">
				<h2 className="text-2xl font-bold tracking-tight text-gray-900 lg:text-3xl">
					{t('title')}
				</h2>
				<div className="mt-10 grid grid-cols-2 items-center gap-x-8 gap-y-10 md:grid-cols-4">
					{companies.map((company) => (
						<CompanyLink key={company.id} company={company} prefetch={false}>
							<CompanyLogo
								companyId={company.id}
								alt={company.name}
								width={250}
								height={100}
								className="h-[50px] w-auto object-contain object-left hover:opacity-75"
							/>
						</CompanyLink>
					))}
				</div>
			</div>
		</div>
	);
}
